<template>
<div class="chapter">
<div class="inner_page">
<div class="forward">
<h1>Praise for <i>Gangs of America</i></h1>
<p><span>“An important and highly accessible book about the legal and political environments that shaped the modern corporation. Highly recommended.”</span></p>
<div class="cite">
<p><span>—<i>Choice</i></span></p>
</div>
<p><span>“A joy to read … clear, straight-forward, and very accessible … one of those books that can awaken people’s consciousness.”</span></p>
<div class="cite">
<p><span>—<i>Corporate Reform Weekly</i></span></p>
</div>
<p><span>“Entertaining and sometimes arresting … the book is a lively read, and Nace is an interesting companion.”</span></p>
<div class="cite">
<p><span>—<i>New Leader</i></span></p>
</div>
<p><span><i>“Gangs of America</i> is a brilliant page-turner revealing how powerful, greedy corporations wage institutional terrorism. Reading it is the first step to saving our communities, our democracy, and our planet’s environment.”</span></p>
<div class="cite">
<p><span>—John Stauber, coauthor of <i>Toxic Sludge Is Good for You!</i></span></p>
</div>
<p><span>“A beautifully documented and readable history.”</span></p>
<div class="cite">
<p><span>—Ben H. Bagdikian, author of <i>The Media Monopoly</i></span></p>
</div>
<p><span>“The essential guide to the history of the American corporation. Nace explodes the myth of inevitability surrounding the corporate takeover of our lives.”</span></p>
<div class="cite">
<p><span>—Maria Elena Martinez, executive director, CorpWatch</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epub_9781605097121_3.vue?0628f7f2